import { useState } from 'react';
import { StyledLink } from '../../components/common-components/link/styled-link.component';
import { ACCOUNT_PROJECTS_DETAILS } from '../../constants/links';
import { buildGTMProjectInteractionTracking } from '../../helpers/analytics/gtm/gtm-utils.helper';
import { generatePath } from '../../utils/routing/route.utils';
import { useTrackEvent } from '../analytics/analytics.hooks';
import { useNotification } from '../notification/notification.hooks';

type ProjectCreationDrawerResult = {
	isNewProjectDrawerOpen: boolean;
	openCreateProjectDrawer: () => void;
	closeCreateProjectDrawer: () => void;
	onProjectCreated: () => void;
	notifySuccessOnCreation: (projectId: number, name: string) => void;
};

export const useProjectCreationDrawer = (trackOpenLocation?: string, getProjects?: () => void): ProjectCreationDrawerResult => {
	const track = useTrackEvent();
	const { notifySuccess } = useNotification();
	const [isNewProjectDrawerOpen, setIsNewProjectDrawerOpen] = useState<boolean>(false);

	const openCreateProjectDrawer = () => {
		setIsNewProjectDrawerOpen(true);
		if (trackOpenLocation) {
			track(buildGTMProjectInteractionTracking(trackOpenLocation, 'create-project'));
		}
	};

	const closeCreateProjectDrawer = () => setIsNewProjectDrawerOpen(false);

	const onProjectCreated = () => {
		if (getProjects) {
			getProjects();
		}
		closeCreateProjectDrawer();
	};

	const notifySuccessOnCreation = (projectId: number, name: string) => {
		notifySuccess(
			<div>
				<div className="font-medium mb2">The {name} project has been created!</div>
				<StyledLink url={generatePath(ACCOUNT_PROJECTS_DETAILS, { projectId })}>Go to Project</StyledLink>
			</div>
		);
		closeCreateProjectDrawer();
	};

	return {
		isNewProjectDrawerOpen,
		openCreateProjectDrawer,
		closeCreateProjectDrawer,
		onProjectCreated,
		notifySuccessOnCreation
	};
};
